import type { ReactElement } from 'react';
import { Route } from 'config';

type Props = {
  isFavoriteAnnouncement?: boolean;
  onClose: () => void;
};

function TutorialTooltip({
  isFavoriteAnnouncement,
  onClose,
}: Props): ReactElement {
  return (
    <div className={`c-tooltip c-tooltip--${isFavoriteAnnouncement ? 'favorites' : 'change-meals'}`}>
      <div className="c-tooltip__content c-tooltip__content--tutorial">
        {isFavoriteAnnouncement ? (
          <p>
            Come back to your favorite recipes, anytime!
            Save by clicking the heart button and find
            your favorite recipes in&nbsp;
            <a href={Route.MY_FAVORITES} className="d-inline-block">My Favorites</a>
            .
          </p>
        ) : (
          <p>
            Manage your weekly delivery by clicking&nbsp;
            <strong className="d-inline-block">Change Meals</strong>
            .
          </p>
        )}
        <button
          type="button"
          aria-label="Close"
          data-dismiss="c-tutorial-tooltip"
          className="c-tutorial-tooltip__close"
          onClick={onClose}
        >
          Got it
        </button>
      </div>
    </div>
  );
}

export default TutorialTooltip;
